import { WbGrid, WbGridCol, WbGridRow } from "@workbench/react";
import "../../styles/Footer.css";

const Footer: React.FC = () => {
  return (
    <WbGrid>
      <WbGridRow>
        <WbGridCol
          mq1={12}
          className="footer-border-col wb-padding-top-s wb-padding-bottom-xs"
        >
          <hr className="footer-border" />
        </WbGridCol>
      </WbGridRow>
      <WbGridRow>
        <WbGridCol
          mq1={12}
          mq3={6}
          className="footer-content-col wb-padding-bottom-xs"
        >
          <span className="footer-text">
            &copy;{new Date().getFullYear()} Mercedes-Benz
          </span>
        </WbGridCol>
        <WbGridCol
          mq1={12}
          mq3={6}
          className="footer-content-col footer-links wb-padding-bottom-xs"
        >
          <a
            className="footer-link"
            href="https://www.mercedes-benz.com/en/#provider"
            target="_blank"
            rel="noreferrer"
          >
            Imprint
          </a>
          <span className="footer-divider">|</span>
          <a
            className="footer-link"
            href="https://www.mercedes-benz.com/en/#privacyStatement"
            target="_blank"
            rel="noreferrer"
          >
            Data Privacy
          </a>
        </WbGridCol>
      </WbGridRow>
    </WbGrid>
  );
};

export default Footer;
